/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { Button, Card, CardBody, Heading, Flex } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import FormInput from "../../components/forms/form-Input";
import {
  useEditCurrency,
  useGetCurrencyDetails,
} from "../../services/currency-api";
import ReactHookFormDropdown from "../../components/forms/react-hook-dropdown";
import NumericInput from "../../components/forms/react-hook-numeric-input";
import {
  CURRENCY_SHAPES,
  CURRENCY_TYPES,
  DEFAULT_CURRENCY,
  DEFAULT_MULTIPLE,
} from "./constants";

export default function EditCurrency() {
  const [currencyDetails, setCurrencyDetails] = useState(null);
  const [currentEditingMultiple, setCurrentEditingMultiple] = useState(null);
  const navigate = useNavigate();
  const params = useParams();

  const {
    mutate: getDetails,
    data: detailsRes,
    isPending: gettingDetails,
    reset: detailsReset,
  } = useGetCurrencyDetails();
  const {
    mutate: createRequest,
    data: createRequestRes,
    isPending: creatingRequest,
  } = useEditCurrency();
  useEffect(() => {
    if (params.currencyId) {
      getDetails(params.currencyId);
    }
  }, []);

  useEffect(() => {
    if (createRequestRes) {
      navigate(Paths.currency);
    }
    if (detailsRes) {
      const _res = detailsRes.data;
      setCurrencyDetails({ ...detailsRes.data });
      reset({
        ...DEFAULT_CURRENCY,
        ..._res,
        type: { id: _res.type, text: _res.type },
        multiples: _res.multiples.map((elm) => ({
          value: elm.value,
          shape: { id: elm.shape, text: elm.shape },
        })),
      });
      detailsReset();
    }
  }, [createRequestRes, detailsRes]);
  const {
    handleSubmit,
    control,
    reset,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: { ...DEFAULT_CURRENCY },
  });

  const generalFieldProps = { errors, control };
  const formValidationRules = {
    name: {
      required: "Please add currency name",
      maxLength: {
        value: 100,
        message: "Value exceeds maximum number of characters (100)",
      },
    },
    shortName: {
      required: "Please add short name",
      maxLength: {
        value: 3,
        message: "Value exceeds maximum number of characters (3)",
      },
    },
    symbol: {
      required: "Please add currency symbol",
      maxLength: {
        value: 3,
        message: "Value exceeds maximum number of characters (3)",
      },
    },
    type: { required: "Please select type" },
    sequence: { required: "Please add sequence" },
  };
  const { fields: multiples, remove: multiplesRemove } = useFieldArray({
    control: generalFieldProps.control,
    name: "multiples",
  });

  const submitInfo = (data) => {
    const payload = {
      id: currencyDetails.id,
      name: data.name,
      shortName: data.shortName,
      symbol: data.symbol,
      type: data.type?.id || "",
      sequence: data.sequence,
      multiples: data.multiples.map((elm) => ({
        value: elm.value,
        shape: elm.shape?.id || "",
      })),
    };
    createRequest(payload);
  };
  const addMultiple = () => {
    const data = getValues();
    clearErrors(["value", "shape"]);
    let isDataValid = true;
    if (!data.value || data.value === "0") {
      setError("value", { type: "required", message: "Please add value" });
      isDataValid = false;
    }
    if (!data.shape) {
      setError("shape", { type: "required", message: "Please select shape" });
      isDataValid = false;
    }
    if (isDataValid) {
      const _multiples = [...multiples];
      const _item = { value: data.value, shape: data.shape };
      if (currentEditingMultiple !== null) {
        _multiples[currentEditingMultiple] = { ..._item };
        setCurrentEditingMultiple(null);
      } else {
        _multiples.push({ ..._item });
      }
      reset({ ...data, ...DEFAULT_MULTIPLE, multiples: [..._multiples] });
    }
  };

  const cancelEditing = () => {
    setCurrentEditingMultiple(null);
    reset({ ...getValues(), ...DEFAULT_MULTIPLE, multiples: [...multiples] });
  };

  const editCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit"
          cursor="pointer"
          onClick={() => {
            reset({ ...getValues(), ...dataItem, multiples: [...multiples] });
            setCurrentEditingMultiple(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Operational Window"
          cursor="pointer"
          onClick={() => {
            multiplesRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  return (
    <>
      {creatingRequest || gettingDetails ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Currencies", link: Paths.currency },
            { text: "Edit Currency", isCurrentPage: true },
          ]}
        />
        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <form
                className="add-location-form"
                onSubmit={handleSubmit(submitInfo)}
              >
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Name"
                  name="name"
                  rules={formValidationRules.name}
                />

                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Short Name"
                  name="shortName"
                  rules={formValidationRules.shortName}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Symbol"
                  name="symbol"
                  rules={formValidationRules.symbol}
                />

                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Type"
                  name="type"
                  id="id"
                  text="text"
                  data={CURRENCY_TYPES}
                  placeholder="Select Type"
                  rules={formValidationRules.type}
                />

                <NumericInput
                  {...generalFieldProps}
                  isRequired
                  label="Sequence"
                  name="sequence"
                  rules={formValidationRules.sequence}
                />
                <Heading
                  style={{ fontSize: "16px", margin: "12px 0", width: "100%" }}
                >
                  Multiples
                </Heading>
                <NumericInput
                  {...generalFieldProps}
                  isRequired
                  label="Value"
                  name="value"
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Shape"
                  name="shape"
                  id="id"
                  text="text"
                  placeholder="Select Shape"
                  data={CURRENCY_SHAPES}
                />
                <Flex
                  w="100%"
                  justify="flex-end"
                  flexDirection="row"
                  gap="12px"
                >
                  {currentEditingMultiple !== null ? (
                    <Button type="button" onClick={cancelEditing}>
                      Cancel
                    </Button>
                  ) : (
                    <></>
                  )}

                  <Button type="button" onClick={addMultiple}>
                    {currentEditingMultiple !== null
                      ? "Update Multiple"
                      : " Add Multiple"}
                  </Button>
                </Flex>
                <Grid data={multiples}>
                  <GridColumn title="Value" field="value" />
                  <GridColumn title="Shape" field="shape.text" />
                  <GridColumn title="Edit" cell={editCell} width={120} />
                  <GridColumn title="Delete" cell={deleteCell} width={120} />
                </Grid>
                <Flex w="100%" justify="flex-end" flexDirection="row">
                  <Button type="submit">Update Currency</Button>
                </Flex>
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
